var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-button"},[_c('router-link',{attrs:{"to":_vm.routeLink},nativeOn:{"click":function($event){return _vm.routeChangeEmit($event)}}},[_vm._v("\n    "+_vm._s(_vm.routeName)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }